<template>
	<div class="book-content">
		<navBar>{{ title }}</navBar>
		<div class="content-box">
			<div class="contentList">
				<div class="font28 title">{{chapterList.name}}</div>
				<div class="df dianBox">
					<div class="dian guo"></div>
					<div class="dian guo"></div>
					<div class="dian active"></div>
					<div class="dian"></div>
				</div>
				<div class="chapterList" v-for="(item, i) in ListData" :key="i" @click="goPage(item,i)">
					<div class="font28 df-a">
						<img v-if="userInfs.mode==1" :src="item.isstudy == 1 ? icon6 : i == 0?icon6:icon7" alt="" />
						<img v-else :src="icon6" alt="" />
						{{ item.name }}
					</div>
					<div class="df-sb xingbox">
						<div class="df">
							<van-icon name="star" color="#E6E6E6" size="0.28rem" />
							<van-icon name="star" color="#E6E6E6" size="0.28rem" />
							<van-icon name="star" color="#E6E6E6" size="0.28rem" />
						</div>
						<!-- <div class="xuefen mCc font24">学分：{{item.usercreditsum}}/{{item.creditsum}}</div> -->
						<div class="font20 mCc">待学习</div>
					</div>
				</div>
				<div class="chapterList" @click="goPageCou">
					<div class="font28 df-a">
						<img :src="icon8" alt="" />
						错题订正单元
					</div>
					<div class="font20 mCG xingbox">共有{{cuoData.length}}个错题</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '人教版-七年级上册',
			icon3: require('../../assets/img/study/icon-3.png'),
			icon4: require('../../assets/img/study/icon-4.png'),
			icon5: require('../../assets/img/study/icon-5.png'),
			icon6: require('../../assets/img/study/icon-6.png'),
			icon7: require('../../assets/img/study/icon-7.png'),
			icon8: require('../../assets/img/study/icon-8.png'),
			chapterList:  this.$store.getters['common/getWordsList'],
			ListData:[],
			cuoData:[],
			userInfs:this.$store.getters['userCenter/getUserInfs']
		};
	},
	created() {
		this.getwrongquestionlist();
		this.getlastchapterlist()
	},
	methods: {
		getlastchapterlist(){
			try{
				this.$api
					.getlastchapterlist({
						bookid:this.$route.query.bookid,
						pid:this.$route.query.id
					})
					.then((res) => {
				
						this.ListData = res.data;
					});
				
			}catch(e){
				//TODO handle the exception
			}
		},
		getwrongquestionlist(){
			try{
				this.$api
					.getwrongquestionlist({
						bookid:this.chapterList.book_id,
						chapterid:this.chapterList.id
					})
					.then((res) => {
						this.cuoData = res.data;
					});
				
			}catch(e){
				//TODO handle the exception
			}
		},
		goPage(item,i) {
			// let path = item.name != '同步课堂' ? '/topicLibrary' : '/videolist';
			// console.log(item,'children')
			if(this.userInfs.mode==1&&i != 0&&item.isstudy == 0){
				this.$toast({
					message: '请先学习上个模块'
				});
				return
			}
			let  id = [];
			if(item.type == 2){
				if(item.children.length>0){
					for (let i = 0; i < item.children.length; i++) {
						id.push(item.children[i].id)
					}
				}
			}else{
				id.push(item.id)
			}
			if(item.name != '同步课堂'){
				if(item.name == "知识要点"){
					item.id = id.join();
				}
				this.newFn(item)
			}else{
				this.$router.push({
					path:  '/videolist',
					query: {
						name: item.name,
						type: 0,
						id: id.join(),
						istong: 0,
						bookid:item.book_id,
						chapterid: item.id
					}
				});
			}
		},
		newFn(item){
			let _path = '';
			if (item.type == 0) {
				_path = '/textContent';
			}
			if (item.type == 1 || item.type == 3|| item.type == 2) {
				if (item.title == '拼写') {
					for (let i = 0; i < this.menuList.length; i++) {
						if (this.menuList[i].title == '速记') {
							break;
						}
					}
				}
				_path = '/questionContent';
			}
		
			if (item.name == '课后练兵') {
				_path = '/userTest';
			}
			this.$router.push({
				path: _path,
				query: {
					name: item.name,
					id: item.id,
					type: item.type,
					// class: this.$route.query.class,
					courseId: item.book_id,
					chapterid:this.chapterList.id,
					// binddata: item.binddata,
					istong:	this.isfather?1:0
				}
			});
		},
		goPageCou(){
			this.$router.push({
				path: '/questionContent',
				query: {
					name:'错题订正单元',
					type: 2,
					id: this.chapterList.id,
					bookid: this.chapterList.book_id,
					isCuo:1
				}
			});
		},
	}
};
</script>

<style lang="scss" scoped>
.content-box {
	height: calc(100% - 1.08rem);
	padding: 0.34rem 0.28rem 0 0.28rem;
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	// min-height: 100vh;
	background: #f5faff;

	.contentList {
		.dianBox {
			margin-top: 0.2rem;
			margin-bottom: 0.35rem;
			.dian {
				width: 0.15rem;
				height: 0.15rem;
				// background: #6D9CD4;
				background: #ececec;
				border-radius: 0.02rem;
				margin-right: 0.1rem;
				&.active {
					background-color: #48aa89;
				}
				&.guo {
					background-color: #6b9bdb;
				}
			}
		}
		.chapterList {
			width: 100%;
			height: 1.46rem;
			background: #ffffff;
			border-radius: 0.1rem;
			padding: 0.28rem;
			margin-bottom: 0.24rem;
			img {
				width: 0.3rem;
				margin-right: 0.1rem;
			}
			.xingbox {
				margin-top: 0.24rem;
			}
		}
	}
}
</style>
